/**
 * Single source of truth for clinical-form print routes.
 */

export const clinicalFormPrintUrl = (patientId, formId) =>
  `/patients/${patientId}/forms/${formId}/print`;

/**
 * Bulk print preview (new tab). Selection order is preserved in `ids`.
 * @param {string|number} patientId
 * @param {Array<string|number>} formIds
 * @param {{ includeAttachments?: boolean }} [options]
 */
export const clinicalFormsBulkPrintUrl = (
  patientId,
  formIds,
  { includeAttachments = false } = {},
) => {
  const ids = (formIds || [])
    .map((id) => Number(id))
    .filter((n) => Number.isInteger(n) && n > 0);
  const params = new URLSearchParams();
  params.set("ids", ids.join(","));
  if (includeAttachments) params.set("attachments", "1");
  return `/patients/${patientId}/forms/bulk-print?${params.toString()}`;
};

/** Max forms allowed in one bulk print session (mirrors backend). */
export const CLINICAL_FORM_BULK_PRINT_MAX = 50;
